export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const WS_BASE_URL = process.env.REACT_APP_WS_URL;
export const ACCESS_TOKEN = 'accessToken';

export const TIME_OPTIONS = {  year: 'numeric', month: 'numeric', day: 'numeric', hour : 'numeric', minute : 'numeric', second : 'numeric' };
